//Horizontal Bar Chart SCRIPT START
var horizontalBarChart = {};
$(document).ready(function () {
    if ($("#apply-filter-pd").length) {
        $.ajax({
            method: "GET",
            url: "/kd_filter",
            dataType: "json",
            success: function (data) {
                var select1 = "<div class='multiselect-control-wrap'><select class='multiselect-control' data-placeholder='Select Region' name='project_region[]' multiple='multiple'>";
                $.each(data.project_region, function (key, value, index) {
                    select1 += '<option value="' + value.project_region + '">' + value.project_region + '</option>';
                });
                select1 += "</select></div>";
                $("#region-data-pd").html(select1);


                var select2 = "<div class='multiselect-control-wrap'><select class='multiselect-control' data-placeholder='Select Value' name='project_state[]' multiple='multiple'>";
                $.each(data.project_state, function (key, value, index) {
                    select2 += '<option value="' + value.project_state + '">' + value.project_state + '</option>';
                });
                select2 += "</select></div>";
                $("#state-data-pd").html(select2);

                $('.multiselect-control').multiselect({
                    includeSelectAllOption: true
                });
            }
        });
        $('.multiselect-control-checkbox').multiselect({
            includeSelectAllOption: true
        });
        $("#apply-filter-pd").click(function () {
            $.ajax({
                method: "GET",
                url: "/kd_ajax",
                dataType: "json",
                data: $('#filter-pd').serialize(),
                success: function (data) {

                    makeHorizontalChart(horizontalBarChart, data);

                }
            });
        });

        $.ajax({
            method: "GET",
            url: "/kd_ajax",
            dataType: "json",
            success: function (data) {

                var graph_labels = [];
                var graph_color = [];
                var graph_data = [];
               
                $.each(data.result, function (key, value) {
                    graph_labels.push(value.key_driver);
                    graph_data.push(value.goal);
                    if (value.assessment_field === 'Technical Aspects') {
                        graph_color.push("#B45F06");
                    }
                    if (value.assessment_field === 'Effectiveness Aspects') {
                        graph_color.push("#741B47");
                    }
                });

                Chart.defaults.global.legend.display = false;
                var ctx2 = document.getElementById('myChart2').getContext('2d');
                horizontalBarChart = new Chart(ctx2, { // The type of chart we want to create
                    type: 'horizontalBar',

                    // The data for our dataset
                    data: {
                        labels: graph_labels,
                        datasets: [
                            {
                                data: graph_data,
                                backgroundColor: graph_color
                            }
                        ]
                    },

                    // Configuration options go here
                    options: {
                        scales: {
                            xAxes: [{
                                ticks: {
                                    display: false,
                                    drawBorder: false,
                                    beginAtZero: true
                                },
                                scaleLabel: {
                                    display: false
                                },
                                gridLines: {
                                    display: false,
                                },
                            }],
                            yAxes: [{
                                gridLines: {
                                    display: false,
                                    drawBorder: false
                                },
                                ticks: {
                                    fontFamily: "Quicksand-Medium",
                                    fontSize: 16
                                },
                                scaleLabel: {
                                    display: true,
                                    padding: 50,
                                    labelString: 'EFFECTIVENESS ASPECTS                            TECHNICAL ASPECTS'
                                },
                                barPercentage: 0.5,
                                categoryPercentage: 0.75
                                
                            }]
                        },
                    }
                });
                Chart.defaults.global.defaultFontFamily = 'Quicksand-Medium';
                Chart.defaults.global.defaultFontSize = 14;
            }
        });
    }

});

function makeHorizontalChart(chart, data) {

    var graph_labels = [];
    var graph_color = [];
    var graph_data = [];

    $.each(data.result, function (key, value) {
        graph_labels.push(value.key_driver);
        graph_data.push(value.goal);
        if (value.assessment_field === 'Technical Aspects') {
            graph_color.push("#B45F06");
        }
        if (value.assessment_field === 'Effectiveness Aspects') {
            graph_color.push("#741B47");
        }
    });

    chart.config.data.datasets[0].data = graph_data;
    chart.update();
}
//Horizontal Bar Chart SCRIPT STARTEND

